import { render } from "./SpinnerGlobal.vue?vue&type=template&id=09627374&scoped=true&ts=true"
import script from "./SpinnerGlobal.vue?vue&type=script&lang=ts"
export * from "./SpinnerGlobal.vue?vue&type=script&lang=ts"

import "./SpinnerGlobal.vue?vue&type=style&index=0&id=09627374&lang=scss&scoped=true"

import exportComponent from "C:\\Vyvoj\\temporary\\htdocs\\dev.poski.loc\\clevero.cz\\trunk\\www\\frontend\\CID\\poski\\klasik-2020\\js\\libraries\\store-catalog\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09627374"]])

export default __exports__